import { Children, isValidElement, type ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { branchStatusEnum } from 'korint-sdk';
import { Separator } from '../../ui/separator/separator';
import { ToggleArchiveBranchButton } from '../ToggleArchiveBranchButton';
import { BranchExplorer } from '../BranchExplorer/BranchExplorer';
import { HomeBranchButton } from '../HomeBranchButton';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

export function PolicyHeaderActions({ gestures }: { gestures?: ReactNode }) {
  const { t } = useTranslation();
  const { workingBranch } = usePolicyOnDashboard();
  const navRef = useRef<HTMLDivElement>(null);
  const [hasNav, setHasNav] = useState(false);

  const isArchived = workingBranch?.branchStatus === branchStatusEnum.BRANCH_CLOSED;
  const hasGestures = Children.toArray(gestures).filter(isValidElement).length > 0;

  useLayoutEffect(() => {
    setHasNav(navRef.current ? navRef.current.childElementCount > 0 : false);
  });

  return (
    <Group gap={2}>
      {hasGestures && <Group gap={1}>{gestures}</Group>}
      {hasGestures && hasNav && (
        <Separator orientation="vertical" className="mx-2 h-6 bg-muted-foreground/40" />
      )}
      {isArchived && (
        <Text
          inline
          size="sm"
          weight="bold"
          className="flex h-9 items-center rounded border-2 border-red-700 bg-red-100 px-3 uppercase tracking-wider text-red-700"
        >
          {t('archive.archivedBadge')}
        </Text>
      )}
      <Group ref={navRef} gap={1}>
        <HomeBranchButton />
        <ToggleArchiveBranchButton />
        <BranchExplorer />
      </Group>
    </Group>
  );
}
